// extracted by mini-css-extract-plugin
export default {"light":"styles_light__0Ih+V","connectButton":"styles_connectButton__s8OPw"};